import React, {Component} from 'react';
import LoginForm from './Subcomponents/LoginForm';
import withRouter from './Functions/WithRouter';

class AdvSignIn extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
      console.log('componentDidMount advsignin')

      const fromExternal = this.props.location.state

      let reason = null
      if (this.props.location && this.props.location.search) {
        const searchParams = new URLSearchParams(this.props.location.search);
        reason = searchParams.get("reason");
      }

      if (fromExternal) {
          setTimeout(() => {
              this.setState({animate: true, opacity: 1, fromExternal, reason})
          }, 0.7)
      } else {
          this.setState({animate: true, opacity: 1, fromExternal, reason })
      }
    }

    render() {

      return (
        <div>
          <LoginForm roleName={this.state.roleName} orgCode={this.state.activeOrg} courseId={this.state.courseId} fromExternal={this.state.fromExternal} history={this.props.navigate} reason={this.state.reason} type="SignIn" />
        </div>
      )
    }
}

export default withRouter(AdvSignIn)
